export default "__VITE_ASSET__54708893__"